/* eslint-disable */
import React, { useState, useEffect, act } from "react";
import CopyPassword from "components/CopyPassword/CopyPassword";
import Input from "components/Input/index";
import SelectDropDown from "components/SelectDropDown/SelectDropDown";
import SquareCheckBox from "components/SquareCheckBox/index";
import "./addSecret.scss";
import FileChooser from "components/FileChooser/FileChooser";
import useScreenMobile from "hooks/useScreen";
import FilePicker from "components/FilePicker/FilePicker";
import MultiSelectDropDown from "components/MultiSelectDropDown/MultiSelectDropDown";
import { Operations } from "constants/setup/countries";
import PinSelectFile from "components/SelectObjectsPins/index";
const TTLValues = ["1 Hour", "12 Hours", "1 Day", "7 Days", "30 Days"];

const SecretValues = ["Generate", "Manually", "Upload Binary File"];

const ExpireAlertOptions = [
  "1 Day before",
  "3 Days before",
  "1 Week before",
  "On Expiry",
  "Never"
];

const checkboxData = [
  { label: "Auto - Rotate", checkboxKey: "autoRotate" },
  { label: "Encrypt at rest (default)", checkboxKey: "encryptAtRest" },
  {
    label: "Restrict to attested code (SGX)",
    checkboxKey: "restrictAttestedCode"
  }
];

const AddSecret = ({
  updateOperation, // boolean to check if the operation is an update or add.
  activeTab,
  formData,
  setFormData,
  selectedData,
  setFormErrors,

  formErrors
}) => {

  //the below are for allowed objects in pin
  // Near the top of your AddSecret component, add these state variables
  const [showObjectSelector, setShowObjectSelector] = useState(false);
  const [selectedObjects, setSelectedObjects] = useState([]);




  const isMobile = useScreenMobile({ size: 992 });

  const [selectedCountries, setSelectedCountries] = useState([]);

  const handleCountrySelect = (countries) => {

    setSelectedCountries(countries);
  };

  const handleInputChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      inputs: {
        ...prev.inputs,
        [key]: value
      }
    }));
    setFormErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[key];
      return newErrors;
    });
  };

  const handleSelectChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      selects: {
        ...prev.selects,
        [key]: value
      }
    }));
    setFormErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[key];
      return newErrors;
    });
  };

  const handlePasswordChange = (e) => {
    const password = e.target.value;
    setFormData((prev) => ({
      ...prev,
      inputs: {
        ...prev.inputs,
        password
      }
    }));
    setFormErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors.password;
      return newErrors;
    });
  };

  const handleCheckboxChange = (checkbox) => {
    setFormData((prev) => ({
      ...prev,
      inputs: {
        ...prev.inputs,
        checkboxes: {
          ...prev.inputs.checkboxes,
          [checkbox]: !prev.inputs.checkboxes[checkbox]
        }
      }
    }));
  };

  const handleFileChange = (file) => {
    setFormData((prev) => ({
      ...prev,
      inputs: {
        ...prev.inputs,
        file
      }
    }));
  };
  const handleOperationChange = (selectedOperations) => {
    setFormData((prev) => ({
      ...prev,
      selects: {
        ...prev.selects,
        selectedOperations: selectedOperations
      }
    }));
    setFormErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors.selectedOperations;
      return newErrors;
    });
  };

  return (
    <section className="container addSecretContainer">
      {

        activeTab === 0 && (
          <div style={{ maxWidth: "36rem" }}>

            {/* Object selector button and display */}
            {/* <div className="copyTextContainer">
              <label className="input-label">
                Allowed Objects (UUIDs)<span className="required">*</span>
              </label>

              <div className="selected-objects-container">
                {formData.inputs.allowedObjects && formData.inputs.allowedObjects.length > 0 ? (
                  <div className="selected-objects-list">
                    {formData.inputs.allowedObjects.map((obj, index) => (
                      <div key={index} className="selected-object-item">
                        <span>{obj}</span>
                        <button
                          type="button"
                          className="remove-object-btn"
                          onClick={() => {
                            const newObjects = [...formData.inputs.allowedObjects];
                            newObjects.splice(index, 1);
                            handleInputChange("allowedObjects", newObjects);
                          }}
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="no-objects-selected">No objects selected</div>
                )}

                <button
                  type="button"
                  className="select-objects-btn"
                  onClick={() => setShowObjectSelector(true)}
                >
                  Select Objects
                </button>

                {formErrors.allowedObjects && (
                  <div className="error-message">{formErrors.allowedObjects}</div>
                )}
              </div>
            </div> */}

            {/* Show PinSelectFile modal when needed */}
            {/* {showObjectSelector && (
              <PinSelectFile
                handleCancel={() => setShowObjectSelector(false)}
                currentPath={[]}  // Initial path for file browser
                fetchData={(path) => {
                  // You might need to implement this to refresh data after selection
                  console.log("Fetched path:", path);
                }}
                setCurrentPath={() => { }}  // Handle path changes if needed
                handleSave={(selectedItems) => {
                  // Update form data with selected objects
                  handleInputChange("allowedObjects", [
                    ...formData.inputs.allowedObjects,
                    selectedItems
                  ]);
                  setShowObjectSelector(false);
                }}
              />
            )} */}

            {/* /* add an additional input box for taking the name of pin to be updated */ }
            {!updateOperation && (
              <div className="copyTextContainer" style={{ marginTop: "1rem" }}>
                <Input
                  label="PIN Name"
                  star="*"
                  type="text"
                  placeholder="Enter PIN Name"
                  maxLength={100}
                  inputKey="pinName"
                  mockClass="secretInput"
                  value={formData.inputs.key ?? ""}
                  onChange={(e) => handleInputChange("key", e.target.value)}
                  errorMessage={formErrors.pinName}
                  required
                />
              </div>
            )}

            {/* readonly pin name */}
            {updateOperation && (
              <div className="copyTextContainer" style={{ marginTop: "1rem" }}>
                <Input
                  label="PIN Name"
                  star="*"
                  type="text"
                  placeholder="Enter PIN Name"
                  maxLength={100}
                  inputKey="pinName"
                  mockClass="secretInput"
                  value={formData.inputs.key?? ""}
                  onChange={() => { }}
                  errorMessage={formErrors.pinName}
                  required
                  disabled
                />
              </div>
            )}
            {/* Only show PIN input when creating new PIN, hide when editing */}
            {!updateOperation && (
              <div className="copyTextContainer" style={{ marginTop: "1rem" }}>
                <Input
                  label="PIN"
                  star="*"
                  type="text"
                  placeholder="Enter 6-digit PIN"
                  maxLength={6}
                  inputKey="pin"
                  mockClass="secretInput"
                  value={formData.inputs.pin??""}
                  onChange={(e) => handleInputChange("pin", e.target.value.replace(/\D/g, ""))}
                  errorMessage={formErrors.pin}
                />
              </div>
            )}
            {/* {(
        <div className="copyTextContainer" style={{ marginTop: "1rem" }}>
          <Input
            label="Allowed Objects(ACL)"
            star="*"
            type="text"
            placeholder="select the objects allowed for this PIN"
            maxLength={6}
            inputKey="Allowed Objects(ACL)"
            mockClass="secretInput"
            value={formData.inputs.pin}
            onChange={(e) => handleInputChange("pin", e.target.value.replace(/\D/g, ""))}
            errorMessage={formErrors.pin}
          />
        </div>
      )} */}

            {/* {updateOperation && (
        <div className="editingPinInfo" style={{ color: window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'white' : 'black' }}>
          <p>Editing operations for PIN: <strong>{formData.inputs.pin}</strong></p>
        </div>
      )} */}

            <div style={{ padding: "14px 14px 14px 14px" }}></div>
            <div>
              <MultiSelectDropDown
                onSelectCountries={handleOperationChange}
                width="100%"
                label={"Operations"}
                data={Operations}
                placeholder="Select Operations"
                selectedCountries={formData.selects.selectedOperations || []}
              />
            </div>
          </div>
        )
      }
      {activeTab != 0 && <Input // for all
        label="Secret Path"
        star="*"
        placeholder="Add path"
        inputKey="secretPath"
        mockClass="secretInput"
        maxLength={600}
        value={formData.inputs.secretPath}
        onChange={(e) => handleInputChange("secretPath", e.target.value)}
        errorMessage={formErrors.secretPath}
      />}

      {
        activeTab === 1 && <div>
          <Input
            label="Token key"
            star="*"
            placeholder="Enter token key"
            inputKey="tokenKey"
            mockClass="secretInput"
            maxLength={4096}
            value={formData.inputs.tokenKey}
            onChange={(e) => handleInputChange("tokenKey", e.target.value)}
            errorMessage={formErrors.tokenKey}
          />
        </div>
      }
      {
        activeTab == 2 && <div>
          {/* user picks a file */}
          <FilePicker
            label="File"
            star="*"
            onFileChange={handleFileChange}
            errorMessage={formErrors.file}
          />
        </div>
      }
      {
        activeTab === 3 && <div style={{ maxWidth: "36rem" }}>
          {/* // he can type the key or select a file use drop down there  */}
          <div style={{ display: "flex" }}>
            <div style={{ flex: 1 }}>
              <SelectDropDown
                label="Key Input Method"
                star="*"
                placeholder="Select method"
                selectedCountry={formData.selects.keyInputMethod}
                data={["Type Key", "Upload Key File"]}
                onSelectCountry={(value) => handleSelectChange("keyInputMethod", value)}
                width="60%"
                errorMessage={formErrors.keyInputMethod}
              />
            </div>
            <div style={{ flex: 2 }}>
              {formData.selects.keyInputMethod === "Upload Key File" ? (
                <div style={{ marginTop: "3px", overflowX: "hidden" }}>
                  <FilePicker
                    label="Key File"
                    star="*"
                    onFileChange={handleFileChange}
                    errorMessage={formErrors.file}
                  />
                </div>
              ) : (
                <Input
                  label="Key"
                  star="*"
                  placeholder="Enter key"
                  inputKey="key"
                  mockClass="secretInput"
                  maxLength={4096}
                  value={formData.inputs.key}
                  onChange={(e) => handleInputChange("key", e.target.value)}
                  errorMessage={formErrors.key}
                />
              )}

            </div>
          </div>
        </div>
      }
      {
        activeTab === 4 && (
          <div style={{ maxWidth: "36rem" }}>
            {(formData.inputs.keyValuePairs).map((pair, idx) => (
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  alignItems: "center",
                  marginBottom: "0.5rem"
                }}
                key={idx}
              >
                <Input
                  label={idx === 0 ? "Key" : ""}
                  star="*"
                  placeholder="Enter key"
                  inputKey={`key-${idx}`}
                  mockClass="secretInput"
                  maxLength={4096}
                  value={pair.key}
                  onChange={e => {
                    const newPairs = [...formData.inputs.keyValuePairs];
                    newPairs[idx].key = e.target.value;
                    setFormData(prev => ({
                      ...prev,
                      inputs: { ...prev.inputs, keyValuePairs: newPairs }
                    }));
                  }}
                  errorMessage={formErrors[`key-${idx}`]}
                />
                <Input
                  label={idx === 0 ? "Value" : ""}
                  star="*"
                  placeholder="Enter value"
                  inputKey={`value-${idx}`}
                  mockClass="secretInput"
                  maxLength={4096}
                  value={pair.value}
                  onChange={e => {
                    const newPairs = [...formData.inputs.keyValuePairs];
                    newPairs[idx].value = e.target.value;
                    setFormData(prev => ({
                      ...prev,
                      inputs: { ...prev.inputs, keyValuePairs: newPairs }
                    }));
                  }}
                  errorMessage={formErrors[`value-${idx}`]}
                />
                {formData.inputs.keyValuePairs.length > 1 && (
                  <button
                    type="button"
                    onClick={() => {
                      const newPairs = formData.inputs.keyValuePairs.filter((_, i) => i !== idx);
                      setFormData(prev => ({
                        ...prev,
                        inputs: { ...prev.inputs, keyValuePairs: newPairs }
                      }));
                    }}
                    style={{
                      background: "none",
                      border: "none",
                      color: "red",
                      fontSize: "1.5rem",
                      cursor: "pointer"
                    }}
                    title="Remove"
                  >
                    &minus;
                  </button>
                )}
              </div>
            ))}
            {!updateOperation && <div style={{ marginTop: "0.5rem" }}>
              <button
                type="button"
                onClick={() => {
                  setFormData(prev => ({
                    ...prev,
                    inputs: {
                      ...prev.inputs,
                      keyValuePairs: [...prev.inputs.keyValuePairs, { key: "", value: "" }]
                    }
                  }));
                }}
                style={{
                  background: "none",
                  border: "none",
                  color: "green",
                  fontSize: "1.5rem",
                  cursor: "pointer"
                }}
                title="Add"
              >+</button>
            </div>}
          </div>
        )
      }
      {
        activeTab === 5 && <div>
          <Input
            label="Website URL"
            star="*"
            placeholder="Add URL"
            inputKey="url"
            mockClass="url"
            maxLength={600}
            value={formData.inputs.url}
            onChange={(e) => handleInputChange("url", e.target.value)}
            errorMessage={formErrors.secretPath}
          />
          <Input
            label="Username"
            star="*"
            placeholder="Add user name"
            inputKey="Username"
            mockClass="Username"
            maxLength={600}
            value={formData.inputs.username}
            onChange={(e) => handleInputChange("username", e.target.value)}
            errorMessage={formErrors.secretPath}
          />
          <Input
            label="Password"
            star="*"
            placeholder="Add password"
            inputKey="password"
            mockClass="password"
            maxLength={600}
            value={formData.inputs.password}
            onChange={(e) => handleInputChange("password", e.target.value)}
            errorMessage={formErrors.secretPath}
          />
          <Input
            label="TOTP"
            star="*"
            placeholder="Add TOTP"
            inputKey="totp"
            mockClass="totp"
            maxLength={600}
            value={formData.inputs.totp}
            onChange={(e) => handleInputChange("totp", e.target.value)}
            errorMessage={formErrors.secretPath}
          />


        </div>
      }
      {
        activeTab === 1000 && <div className="passwordInputContainer">
          <SelectDropDown
            label="Secret Values"
            star="*"
            placeholder="Select value method"
            selectedCountry={formData.selects.selectedSecretValueTTL}
            data={SecretValues}
            onSelectCountry={(value) =>
              handleSelectChange("selectedSecretValueTTL", value)
            }
            width={isMobile ? "90%" : "75%"}
            errorMessage={formErrors.selectedSecretValueTTL}
          />

          {formData.selects.selectedSecretValueTTL === "Upload Binary File" ? (
            <FileChooser
              onFileChange={handleFileChange}
              errorMessage={formErrors.file}
            />
          ) : (
            <CopyPassword
              inputWidth={isMobile ? "90%" : "51%"}
              value={formData.inputs.password}
              onChange={handlePasswordChange}
              errorMessage={formErrors.password}
            />
          )}
        </div>
      }

      {!(updateOperation && activeTab === 0) && <SelectDropDown
        label="Time To Live"
        star="*"
        placeholder="Select TTL"
        selectedCountry={formData.selects.selectedTTL}
        data={TTLValues}
        onSelectCountry={(value) => handleSelectChange("selectedTTL", value)}
        width={isMobile ? "90%" : "92%"}
        errorMessage={formErrors.selectedTTL}
      />
      }

      {0 === 1 && <SelectDropDown // TODO:: no use as of now.
        label="Expire Alert"
        star="*"
        placeholder="Select alert timing"
        selectedCountry={formData.selects.selectedExpireAlert}
        data={ExpireAlertOptions}
        onSelectCountry={(value) =>
          handleSelectChange("selectedExpireAlert", value)
        }
        width={isMobile ? "90%" : "92%"}
        errorMessage={formErrors.selectedExpireAlert}
      />}

      {/* <FilePicker label="Certificate" star="*" onFileChange={handleFileChange}
        errorMessage={formErrors.file} /> */}
      {/* {
        activeTab === 0 && <div style={{ maxWidth: "36rem" }}>
          <div className="copyTextContainer" style={{ marginTop: "1rem" }}>
            <Input
              label="PIN"
              star="*"
              type="text"
              placeholder="Enter 6-digit PIN"
              maxLength={6}
              inputKey="PIN"
              mockClass="secretInput"
              value={formData.inputs.pin}
              onChange={(e) => handleInputChange("pin", e.target.value.replace(/\D/g, ""))}
              errorMessage={formErrors.pin}
            />
          </div>
          <div style={{ padding: "14px 14px 14px 14px" }}></div>
          <div >
            <MultiSelectDropDown
              onSelectCountries={handleOperationChange}
              width="100%"
              label={"Operations"}
              data={Operations}
              placeholder="Select Operations"
              selectedCountries={formData.selects.selectedOperations || []}
            />
          </div>
        </div>
      } */}
      {0 == 1 && <Input
        label="Description"
        width="80%"
        mockClass="secretInput"
        placeholder="Add description"
        inputKey="description"
        value={formData.inputs.description}
        onChange={(e) => handleInputChange("description", e.target.value)}
        errorMessage={formErrors.description}
      />}

      <div className="rotateData">
        {0 === 1 && checkboxData.map(({ label, checkboxKey }, index) => ( // TODO:: no use as of now.
          (<div key={checkboxKey} className="rotateContainer">
            <div
              className="autoRotateEnabled"
              onClick={() => handleCheckboxChange(checkboxKey)}
            >
              <SquareCheckBox
                label=""
                isChecked={formData.inputs.checkboxes[checkboxKey]}
                isDisable={false}
                onChange={() => handleCheckboxChange(checkboxKey)}
              />
              <p className="autoRotate">{label}</p>
            </div>
            <div className="autoRotateSelect">
              {checkboxKey === "autoRotate" &&
                formData.inputs.checkboxes.autoRotate && (
                  <div className="selectTime">
                    <SelectDropDown
                      label="Time Duration for Auto - rotate"
                      star="*"
                      placeholder="Select Time"
                      selectedCountry={formData.selects.autoRotateTTL}
                      data={TTLValues}
                      onSelectCountry={(value) =>
                        handleSelectChange("autoRotateTTL", value)
                      }
                      width="91%"
                      errorMessage={formErrors.autoRotateTTL}
                    />
                  </div>
                )}
            </div>
          </div>)
        ))}
      </div>
    </section>
  );
};

export default AddSecret;
